import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { TextField } from '@mui/material';
import { useReportsVersion, useUpdateReportsVersion } from '~/reports-version';
import Dimmer from '+/Dimmer';
import Swal from '#/swal';


const List = () => {

    const {
        isLoading, isError, data, isFetching
    } = useReportsVersion();

    const { mutate: updateReportsVersion } = useUpdateReportsVersion();


    if (isLoading || isFetching) {
        return <Dimmer />;
    }

    if (isError) {
        return 'Internal Error - Contact Technical Support';
    }

    const columns = [
        {
            field: 'report_name',
            headerName: 'Report Name',
            width: 400,
            editable: false
        },
        {
            field: 'entrata_name',
            headerName: 'Entrata Name',
            width: 400,
            editable: false
        },
        {
            field: 'version',
            headerName: 'Version',
            type: 'string',
            width: 280,
            renderCell: params => (
                <TextField
                    variant='standard'
                    name={params.row.entrata_name}
                    onBlur={handleBlur}
                    onKeyUp={event => {
                        if (event.key === 'Enter')
                            event.target.blur();
                    }}
                    defaultValue = {params.row.version}
                />
            )
        }
    ];


    const handleBlur = e => {

        updateReportsVersion({
            payload: {
                name: e.target.name,
                version: e.target.value
            }
        });

        Swal.fire(
            'API Version updated!',
            'You have update the API version correctly!',
            'success'
        );
    };

    const reports_version = [];
    data.map(x => {
        reports_version.push({

            id: x.id,
            report_name: x.report_name,
            entrata_name: x.entrata_name,
            version: x.version

        });

        return reports_version;
    });

    return (


        <div style={{
            height: 600,
            width: '100%'
        }}>
            <DataGrid
                rows={reports_version}
                columns={columns}
                experimentalFeatures={{ newEditingApi: true }}
                oncha
            />
        </div>
    );
};

export default List;
